type Props = {
  size?: number | string;
  color?: string;
  rays?: number;
  className?: string;
  style?: React.CSSProperties;
};

export default function Sunburst({
  size = 520,
  color = "var(--c-brass)",
  rays = 36,
  className,
  style,
}: Props) {
  const cx = 100;
  const cy = 100;
  const r1 = 36;
  const r2 = 96;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      aria-hidden="true"
      focusable="false"
      className={className}
      style={style}
    >
      <g stroke={color} strokeWidth="0.9" strokeLinecap="round" opacity="0.85">
        {Array.from({ length: rays }).map((_, i) => {
          const a = (i / rays) * Math.PI * 2;
          const x1 = cx + Math.cos(a) * r1;
          const y1 = cy + Math.sin(a) * r1;
          const x2 = cx + Math.cos(a) * r2;
          const y2 = cy + Math.sin(a) * r2;
          return <line key={i} x1={x1} y1={y1} x2={x2} y2={y2} />;
        })}
      </g>
      <circle cx={cx} cy={cy} r={r1 - 4} fill="none" stroke={color} strokeWidth="1.2" />
      <circle cx={cx} cy={cy} r={r1 - 12} fill={color} opacity="0.18" />
    </svg>
  );
}
